import React, { useEffect, useState } from 'react';

const ServingsAdjuster = ({
  servings,
  onServingsChange,
  initialChildren,
  initialAdults,
  initialTeens,
  originalServings = 2,
  changeAdults,
  changeTeens,
  changeChildren
}) => {
  const [adults, setAdults] = useState(2);
  const [teens, setTeens] = useState(0);
  const [children, setChildren] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (initialChildren && initialChildren !== children) setChildren(initialChildren);
    if (initialAdults && initialAdults !== adults) setAdults(initialAdults);
    if (initialTeens && initialTeens !== teens) setTeens(initialTeens);
    // eslint-disable-next-line
  }, []);

  const totalEquivalentServings = adults + (teens * 0.9) + (children * 0.7);

  useEffect(() => {
    onServingsChange(Math.round(totalEquivalentServings * 10) / 10);
    if (changeAdults) changeAdults(adults);
    if (changeTeens) changeTeens(teens);
    if (changeChildren) changeChildren(children);
    // eslint-disable-next-line
  }, [adults, teens, children]);

  const handleAdjustment = (type, delta) => {
    switch (type) {
      case 'adults':
        setAdults(prev => Math.max(0, Math.min(12, prev + delta)));
        break;
      case 'teens':
        setTeens(prev => Math.max(0, Math.min(8, prev + delta)));
        break;
      case 'children':
        setChildren(prev => Math.max(0, Math.min(8, prev + delta)));
        break;
      default:
        break;
    }
  };

  const handleDirectInput = (type, value) => {
    const numValue = parseInt(value) || 0;
    switch (type) {
      case 'adults':
        setAdults(Math.max(0, Math.min(12, numValue)));
        break;
      case 'teens':
        setTeens(Math.max(0, Math.min(8, numValue)));
        break;
      case 'children':
        setChildren(Math.max(0, Math.min(8, numValue)));
        break;
      default:
        break;
    }
  };

  const resetToDefault = () => {
    setAdults(2);
    setTeens(0);
    setChildren(0);
  };

  const PersonCounter = ({ label, value, type, emoji, accent }) => (
    <div className="flex flex-col items-center w-full max-w-[110px]">
      <span className="text-xs font-medium mb-2 tracking-wide" style={{ color: '#6c757d' }}>{emoji} {label}</span>
      <div className="flex items-center justify-center space-x-2 w-full">
        <button
          onClick={() => handleAdjustment(type, -1)}
          disabled={value <= 0}
          aria-label={`Retirer un ${label.toLowerCase()}`}
          className={`w-10 h-10 rounded-full shadow flex items-center justify-center text-lg font-bold transition-all
            ${value <= 0
              ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
              : accent
                ? 'bg-green-100 text-white hover:opacity-90'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          style={value > 0 && accent ? { backgroundColor: '#87A96B', color: '#ffffff' } : { color: '#6c757d' }}
        >-</button>
        <input
          type="number"
          value={value}
          onChange={e => handleDirectInput(type, e.target.value)}
          min="0"
          max={type === 'adults' ? 12 : 8}
          className="w-14 h-10 text-center rounded-xl border border-gray-200 bg-gray-50 text-base font-semibold shadow-inner focus:ring-2 focus:border-transparent"
          style={{ fontFamily: 'inherit', accentColor: '#87A96B' }}
        />
        <button
          onClick={() => handleAdjustment(type, 1)}
          disabled={(type === 'adults' && value >= 12) || (type !== 'adults' && value >= 8)}
          aria-label={`Ajouter un ${label.toLowerCase()}`}
          className={`w-10 h-10 rounded-full shadow flex items-center justify-center text-lg font-bold transition-all
            ${(type === 'adults' && value >= 12) || (type !== 'adults' && value >= 8)
              ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
              : accent
                ? 'text-white hover:opacity-90'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          style={!((type === 'adults' && value >= 12) || (type !== 'adults' && value >= 8)) && accent ? { backgroundColor: '#87A96B', color: '#ffffff' } : { color: '#6c757d' }}
        >+</button>
      </div>
    </div>
  );

  const MobilePersonCounter = ({ label, value, type, emoji, accent }) => (
    <div className="flex items-center justify-between py-3 border-b border-gray-100 last:border-b-0">
      <div className="flex items-center space-x-2">
        <span className="text-lg">{emoji}</span>
        <span className="text-sm font-medium" style={{ color: '#2C3E50' }}>{label}</span>
      </div>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => handleAdjustment(type, -1)}
          disabled={value <= 0}
          aria-label={`Retirer un ${label.toLowerCase()}`}
          className={`w-8 h-8 rounded-full shadow flex items-center justify-center text-sm font-bold transition-all
            ${value <= 0
              ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
              : accent
                ? 'text-white hover:opacity-90'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          style={value > 0 && accent ? { backgroundColor: '#87A96B', color: '#ffffff' } : { color: '#6c757d' }}
        >-</button>
        <span className="w-8 text-center text-sm font-semibold" style={{ color: '#2C3E50' }}>{value}</span>
        <button
          onClick={() => handleAdjustment(type, 1)}
          disabled={(type === 'adults' && value >= 12) || (type !== 'adults' && value >= 8)}
          aria-label={`Ajouter un ${label.toLowerCase()}`}
          className={`w-8 h-8 rounded-full shadow flex items-center justify-center text-sm font-bold transition-all
            ${(type === 'adults' && value >= 12) || (type !== 'adults' && value >= 8)
              ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
              : accent
                ? 'text-white hover:opacity-90'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          style={!((type === 'adults' && value >= 12) || (type !== 'adults' && value >= 8)) && accent ? { backgroundColor: '#87A96B', color: '#ffffff' } : { color: '#6c757d' }}
        >+</button>
      </div>
    </div>
  );

  const getSummaryText = () => {
    const parts = [];
    if (adults > 0) parts.push(`${adults} adulte${adults > 1 ? 's' : ''}`);
    if (teens > 0) parts.push(`${teens} ado${teens > 1 ? 's' : ''}`);
    if (children > 0) parts.push(`${children} enfant${children > 1 ? 's' : ''}`);
    
    if (parts.length === 0) return 'Aucune personne';
    return parts.join(', ');
  };

  return (
    <div className="bg-white rounded-[2rem] shadow-xl border border-gray-100 mb-4 max-w-lg mx-auto transition-all">
      {/* Version Desktop */}
      <div className="hidden sm:block px-6 py-8">
        <h4 className="font-semibold text-xl text-center mb-7 tracking-wide" style={{ color: '#2C3E50' }}>Personnes à table</h4>
        <div className="flex justify-center items-center gap-6 w-full mb-7">
          <PersonCounter label="Adultes" value={adults} type="adults" emoji="🧑" accent />
          <PersonCounter label="Ados" value={teens} type="teens" emoji="🧑‍🎓" />
          <PersonCounter label="Enfants" value={children} type="children" emoji="👶" />
        </div>
        <div className="flex flex-col items-center space-y-2 w-full">
          <div className="text-lg font-semibold tracking-wide" style={{ color: '#2C3E50' }}>
            {totalEquivalentServings.toFixed(1)} <span className="font-normal" style={{ color: '#6c757d' }}>portions</span>
          </div>
          {totalEquivalentServings !== originalServings && (
            <div className="flex flex-col items-center">
              <span className="text-xs mb-1" style={{ color: '#6c757d' }}>
                Base : {originalServings} adultes
              </span>
              <button
                onClick={resetToDefault}
                className="text-xs font-medium hover:opacity-70"
                style={{ color: '#2C3E50' }}
              >
                Rétablir la base
              </button>
            </div>
          )}
          {(adults + teens + children) === 0 && (
            <p className="text-xs mt-2" style={{ color: '#E67E22' }}>
              Ajoutez au moins une personne
            </p>
          )}
        </div>
      </div>

      {/* Version Mobile - Dropdown */}
      <div className="block sm:hidden relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full px-4 py-4 flex items-center justify-between"
        >
          <div className="flex flex-col items-start">
            <span className="text-sm font-semibold" style={{ color: '#2C3E50' }}>Personnes à table</span>
            <span className="text-xs" style={{ color: '#6c757d' }}>{getSummaryText()}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-sm font-semibold" style={{ color: '#2C3E50' }}>
              {totalEquivalentServings.toFixed(1)} portions
            </span>
            <svg
              className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{ color: '#6c757d' }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </button>

        {isOpen && (
          <div className="px-4 pb-4 border-t border-gray-100">
            <div className="space-y-0 mb-4">
              <MobilePersonCounter label="Adultes" value={adults} type="adults" emoji="🧑" accent />
              <MobilePersonCounter label="Ados" value={teens} type="teens" emoji="🧑‍🎓" />
              <MobilePersonCounter label="Enfants" value={children} type="children" emoji="👶" />
            </div>
            
            <div className="flex flex-col items-center space-y-2">
              {totalEquivalentServings !== originalServings && (
                <div className="flex flex-col items-center">
                  <span className="text-xs mb-1" style={{ color: '#6c757d' }}>
                    Base : {originalServings} adultes
                  </span>
                  <button
                    onClick={resetToDefault}
                    className="text-xs font-medium hover:opacity-70"
                    style={{ color: '#2C3E50' }}
                  >
                    Rétablir la base
                  </button>
                </div>
              )}
              {(adults + teens + children) === 0 && (
                <p className="text-xs" style={{ color: '#E67E22' }}>
                  Ajoutez au moins une personne
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServingsAdjuster;
